import { dropEndpointIds } from 'root/src/shared/drops/drops.constants';
import { authenticationTypes, userGroups } from 'root/src/shared/constants/auth';
import { otherEndpointType } from 'root/src/shared/descriptions/endpoints/lenses';
export const createDropLandingShortUrlEndpoint = {
    [dropEndpointIds.CREATE_DROP_LANDING_SHORT_URL]: {
        authentication: authenticationTypes.authenticated,
        authenticationRole: userGroups.admin,
        endpointType: otherEndpointType,
        payloadSchema: {
            type: 'object',
            properties: {
                dropId: { type: 'string' },
                userId: { type: 'string' },
            },
            required: ['dropId', 'userId'],
        },
    },
};
